import { useHistory } from 'react-router-dom';
import { isSkunexusUser, removeCurrentPassowrdFromFormProps, removeCurrentPasswordFormFromFormFields } from '../utils';
import { USERS_INDEX_ROUTE } from '../../../modules/users/consts';

export default {
    name: 'userChangePasswordPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'userChangePasswordForm';
        const route = app.routes.getItem(routeName);
        if (route) {
            const routeProps = route.props;

            route.props = (state) => ({
                ...routeProps(state),
                customFormFields: removeCurrentPasswordFormFromFormFields,
                customFormProps: removeCurrentPassowrdFromFormProps,
            });

            (route.render = (Component) =>
                function (props) {
                    let history = useHistory();

                    if (!isSkunexusUser()) {
                        history.push(USERS_INDEX_ROUTE);
                    }

                    return <Component {...props} />;
                }),
                app.routes.changeItem(routeName, route);
        }
    },
};
